/* Talas PDP: "Condition" option (Brand New / Original / Used / PRC), alone or combined with Side (Left / Right).
   Adds on top of assets/talas-pdp.js without editing it:
   1. condition note under the Condition control (rendered by snippets/talas-condition-note.liquid)
   2. "Both (set)" reasons that name the condition ("Right side not available in Used")
   3. title on segments whose combination does not exist (they stay dimmed + selectable, handled by talas-pdp.js)
   4. origin chip follows the selected condition (the condition chip + Part details row are owned by talas-pdp.js initOrigin,
      which reads the per-variant line from snippets/talas-cond-text.liquid)
   Hooks: the theme's "swatch-change" event on .js-swatch-form, "change" on the option inputs, "pdp-both-change".
   Pairing for Both (set) already uses the CURRENT condition in talas-pdp.js (sidePair reads every native option),
   so only the disabled-reason text needs this override. */
(function () {
  'use strict';
  var KEYS = { 'brand new': 'new', 'new': 'new', 'original': 'original', 'used': 'used', 'refurbished': 'refurbished', 'ctr': 'ctr', 'prc': 'prc',
    'أصلي وكالة': 'new', 'جديد': 'new', 'أصلي': 'original', 'مستعمل': 'used', 'مجدّد': 'refurbished', 'تجاري': 'prc' };
  var ORIGIN = { 'new': 'Genuine Tesla', 'original': 'Genuine Tesla', 'used': 'Genuine Tesla', 'refurbished': 'Genuine Tesla', 'prc': 'Aftermarket' };
  /* localised chip text (window.TalasT, layout/theme.liquid); the English value is the fallback */
  function T(k, d) { return window.TalasT ? window.TalasT(k, d) : d; }
  function originLabel(o) { return o === 'Genuine Tesla' ? T('origin_genuine', o) : o === 'Aftermarket' ? T('origin_aftermarket', o) : o; }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function keyOf(v) { return KEYS[String(v || '').trim().toLowerCase()] || ''; }

  function init() {
    var form = document.querySelector('.js-swatch-form');
    var wrapper = document.querySelector('.js-product-wrapper');
    if (!form) return;
    var variants = (window.theme && theme.product && theme.product.variants) || [];
    var condItem = null;
    qa('.js-swatch-item', form).forEach(function (it) {
      var t = it.querySelector('.swatch-title');
      if (t && ((t.getAttribute('data-option-name') || t.textContent.trim().toLowerCase()) === 'condition')) condItem = it;
    });
    if (!condItem) return;
    var condPos = +condItem.getAttribute('data-position');
    var note = document.querySelector('[data-talas-cond-note]');
    var notes = {};
    if (note) {
      try { notes = JSON.parse(note.getAttribute('data-notes')) || {}; } catch (e) {}
      var host = condItem.querySelector('.select-wrapper') || condItem;
      if (note.previousElementSibling !== host || note.parentNode !== condItem) condItem.appendChild(note);
    }

    function nativeOf(it) {
      var sel = it.querySelector('select.single-option-selector');
      if (sel) return sel.value;
      var chk = it.querySelector('input[data-single-option-selector]:checked');
      return chk ? chk.value : undefined;
    }
    function selectedVals() {
      var v = [];
      qa('.js-swatch-item', form).forEach(function (it) { v[+it.getAttribute('data-position') - 1] = nativeOf(it); });
      return v;
    }
    function find(vals) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options, ok = true;
        for (var j = 0; j < o.length; j++) if (vals[j] !== undefined && vals[j] !== o[j]) ok = false;
        if (ok) return variants[i];
      }
      return null;
    }

    /* 1. note */
    function updateNote() {
      if (!note) return;
      var txt = notes[keyOf(nativeOf(condItem))] || '';
      if (note.textContent !== txt) note.textContent = txt;
      note.hidden = !txt;
    }

    /* 3. missing combinations: dimmed + selectable (talas-pdp.js), plus a hint */
    function markMissing() {
      var vals = selectedVals();
      qa('[data-pdp-seg]', form).forEach(function (g) {
        var p = +g.getAttribute('data-option-position') - 1;
        qa('.pdp-seg__opt:not([data-pdp-both])', g).forEach(function (b) {
          var probe = vals.slice(); probe[p] = b.getAttribute('data-pdp-seg-value');
          if (find(probe)) { if (b.getAttribute('data-talas-missing')) { b.removeAttribute('data-talas-missing'); b.removeAttribute('title'); } }
          else { b.setAttribute('data-talas-missing', 'true'); b.setAttribute('title', 'Not currently available'); }
        });
      });
    }

    /* 2. Both (set) reason, naming the condition */
    function refineBoth() {
      var side = form.querySelector('[data-pdp-seg-side]');
      var btn = side && side.querySelector('[data-pdp-both]');
      if (!btn || btn.hidden || !btn.hasAttribute('aria-disabled')) return;
      var sNote = form.querySelector('[data-pdp-seg-note]');
      if (btn.getAttribute('aria-disabled') !== 'true') return;
      if (wrapper && wrapper.classList.contains('pdp-both-on')) return;
      var L = null, R = null, pos = +side.getAttribute('data-option-position');
      qa('.pdp-seg__opt:not([data-pdp-both])', side).forEach(function (b) {
        var x = b.getAttribute('data-pdp-seg-value'), l = x.trim().toLowerCase();
        if (l === 'left') L = x; else if (l === 'right') R = x;
      });
      if (!L || !R || pos === condPos) return;
      var vals = selectedVals(), a = vals.slice(), b = vals.slice();
      a[pos - 1] = L; b[pos - 1] = R;
      var vl = find(a), vr = find(b), c = nativeOf(condItem), why = '';
      if (!vl && !vr) why = 'Left and right sides not available in ' + c;
      else if (!vl) why = 'Left side not available in ' + c;
      else if (!vr) why = 'Right side not available in ' + c;
      else if (!vl.available && !vr.available) why = 'Both sides sold out in ' + c;
      else if (!vl.available) why = 'Left side sold out in ' + c;
      else if (!vr.available) why = 'Right side sold out in ' + c;
      if (!why) return;
      /* Arabic: the sentences above are English-only; compose from existing locale keys instead ("<reason> · <condition>") */
      if (/^ar/i.test(document.documentElement.lang || '')) {
        var cl = T('lbl_' + String(c || '').trim().toLowerCase().replace(/ /g, '_'), c);
        var base = (!vl || !vr) ? T('why_no_set', '') : (!vl.available && !vr.available) ? T('why_both_sold', '') : !vl.available ? T('why_left_sold', '') : T('why_right_sold', '');
        if (base) why = base + ' · ' + cl;
      }
      btn.setAttribute('title', why);
      btn.setAttribute('data-reason', why);
      if (sNote) { sNote.textContent = why; sNote.classList.add('is-on', 'is-warn'); }
    }

    /* 4. chips: the selected condition decides origin (Brand New/Original/Used = Genuine Tesla, PRC = Aftermarket) and the condition chip;
       idempotent, so it can safely re-run after talas-pdp.js rewrites the chips from the variant metafields */
    function setChip(chip, text) {
      if (!chip || !text) return;
      if (chip.textContent !== text) chip.textContent = text;
      if (chip.hidden) chip.hidden = false;
    }
    function fixChips() {
      var c = nativeOf(condItem);
      setChip(document.querySelector('[data-pdp-origin-chip]'), originLabel(ORIGIN[keyOf(c)]));
    }

    function run() { updateNote(); markMissing(); refineBoth(); fixChips(); }
    function schedule() { run(); setTimeout(run, 0); }

    form.addEventListener('swatch-change', schedule);
    condItem.addEventListener('change', schedule);
    form.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.js-swatch-item')) schedule(); });
    document.addEventListener('pdp-both-change', schedule);
    /* talas-pdp.js rewrites the chips on a timer after swatch-change: re-apply the condition when it does */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(fixChips);
      qa('[data-pdp-origin-chip]').forEach(function (ch) {
        mo.observe(ch, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
      });
    }
    window.TalasCondition = { refresh: run };
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
